import {
  Loader,
  Point,
  Ticker,
  Texture,
} from 'pixi.js';
import { random } from 'lodash';
import { isRetina } from '@/scripts/utils';
import gsap from 'gsap';
import Actor from './Actor';
import vars from '../vars';
import state from '../state';

class Rail extends Actor {
  constructor(parent, id) {
    super(parent);
    this.id = id;
    this.frameHandler = () => { this.frame(); };
    this.startIndex = 0;

    this.ref = new global.PIXI.projection.Container2d();
    this.ref.sortableChildren = true;

    this.bottomTiles = [
      new global.PIXI.projection.Sprite2d(
        Loader.shared.resources[`images/BUSH_BOTTOM_${this.id.toUpperCase()}`].texture,
      ),
      new global.PIXI.projection.Sprite2d(
        Loader.shared.resources[`images/BUSH_BOTTOM_${this.id.toUpperCase()}`].texture,
      ),
    ];

    this.bottomTilesMask = new global.PIXI.projection.Sprite2d(Texture.WHITE);
    this.bottomTilesMask.width = 188;
    this.bottomTilesMask.height = 800;

    const whiteTexture = new Texture(Texture.EMPTY.baseTexture);
    whiteTexture.orig.width = 188;
    whiteTexture.orig.height = 800;
    this.bottom = new global.PIXI.projection.Sprite2d(whiteTexture);
    this.bottom.zIndex = -99999999;

    this.bottom.addChild(this.bottomTilesMask);
    this.bottomTiles.forEach((tile) => { this.bottom.addChild(tile); });
    this.ref.addChild(this.bottom);

    this.sprites = [];
    let pool = [1, 2, 3, 4];
    for (let i = 0; i < 15; i += 1) {
      const r = random(0, pool.length - 1, false);
      const k = pool[r];
      pool.splice(r, 1);
      if (pool.length <= 0) { pool = [1, 2, 3, 4]; }
      const sprite = new global.PIXI.projection.Sprite2d(Loader.shared.resources[`images/BUSH_${k}`].texture);
      sprite.proj.affine = global.PIXI.projection.AFFINE.AXIS_X;
      sprite.zIndex = i;
      if (this.id === 'right') sprite.scale.x *= -1;
      this.sprites.push(sprite);
      this.ref.addChild(sprite);
    }

    this.resize();
    this.parent.addChild(this.ref);

    Ticker.shared.add(this.frameHandler);
  }

  resize() {
    this.bottom.anchor = new Point(0.5, 0);
    this.bottom.position.y = -630;
    this.bottom.position.x = this.id === 'left' ? -(this.parent.width / 2) : (this.parent.width / 2);
    this.bottomTilesMask.position.x = -this.bottom.width / 2;

    this.bottomTiles[0].height = 800;
    this.bottomTiles[1].height = 800;
    this.bottomTiles[0].position.x = -this.bottom.width / 2;
    this.bottomTiles[1].position.x = -this.bottom.width / 2;
    this.bottomTiles[0].position.y = 0;
    this.bottomTiles[1].position.y = -800;
    this.bottomTiles[0].mask = this.bottomTilesMask;
    this.bottomTiles[1].mask = this.bottomTilesMask;

    this.sprites.forEach((sprite, index) => {
      sprite.anchor = new Point(0.5, 1);
      sprite.width = vars.layout.RAILS_SPRITE_WIDTH;
      sprite.height = vars.layout.RAILS_SPRITE_HEIGHT;
      sprite.position.y = -600 + (66.6 * index);
      const tollerance = 5;
      const shift = 80;
      const t = random(shift, shift + tollerance);
      sprite.position.x = this.id === 'left' ? -((this.parent.width / 2) + t) : ((this.parent.width / 2) + t);
    });
  }

  frame() {
    this.bottomTiles[0].position.y += state.speed;
    this.bottomTiles[1].position.y += state.speed;
    if (this.bottomTiles[1].position.y > 0) {
      this.bottomTiles[0].position.y = 0;
      this.bottomTiles[1].position.y = -800;
    }

    this.sprites.forEach((sprite) => {
      sprite.position.y += state.speed;
      if (sprite.position.y > 400) {
        sprite.position.y = -600;
        this.startIndex -= 1;
        sprite.zIndex = this.startIndex;
        this.ref.sortChildren();

        // Set up the animation
        const originalX = sprite.position.x;
        if (this.id === 'left') {
          sprite.position.x -= 80;
          sprite.scale.y = 0.8;
        } else {
          sprite.position.x += 80;
          sprite.scale.y = 0.8;
        }
        gsap.to(sprite.position, { x: originalX, ease: 'power2.inOut', duration: 3 });
        gsap.to(sprite.scale, { y: isRetina() ? 0.5 : 1, ease: 'power2.inOut', duration: 2 });
      }
    });
  }

  destroy() {
    Ticker.shared.remove(this.frameHandler);
    this.ref.destroy({ children: true });
  }
}

export default Rail;
